import { Component, OnInit } from '@angular/core';
// import { CheckoutDeliveryFacade } from '@spartacus/checkout/root';
import { TranslationService, UserAddressService, TranslatePipe } from '@spartacus/core';
import { GlobalMessageService } from '@spartacus/core';
import { AddressBookComponent, AddressBookComponentService } from '@spartacus/user/profile/components';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { KnBrAddress } from 'src/app/models/kn-br-order.model';
import { KnBrAddressCardComponent } from './kn-br-address-card/kn-br-address-card.component';
import { SpinnerComponent } from '@spartacus/storefront';
import { KnBrAddressFormComponent } from './kn-br-address-form/kn-br-address-form.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-kn-br-address-book',
    templateUrl: './kn-br-address-book.component.html',
    styleUrls: ['./kn-br-address-book.component.scss'],
    imports: [KnBrAddressCardComponent, SpinnerComponent, KnBrAddressFormComponent, AsyncPipe, TranslatePipe]
})
export class KnBrAddressBookComponent extends AddressBookComponent implements OnInit {
  constructor(
    public service: AddressBookComponentService,
    protected translation: TranslationService,
    protected globalMessageService: GlobalMessageService,
    protected userAddressService: UserAddressService // protected checkoutDeliveryService: CheckoutDeliveryFacade
  ) {
    super(service, translation, globalMessageService);
  }
  ngOnInit(): void {
    super.ngOnInit();
  }

  getKnbrCardContent(address: KnBrAddress) {
    return combineLatest([
      this.translation.translate('addressCard.default'),
      this.translation.translate('addressCard.setAsDefault'),
      this.translation.translate('common.delete'),
      this.translation.translate('common.edit'),
      this.translation.translate('addressBook.areYouSureToDeleteAddress'),
    ]).pipe(
      map(([defaultText, setAsDefaultText, textDelete, textEdit, textVerifyDeleteMsg]) => {
        let region = '';

        if (address.region && address.region.isocode) {
          region = address.region.isocode;
        }

        const actions: { name: string; event: string }[] = [];
        if (!address.defaultAddress) {
          actions.push({ name: setAsDefaultText, event: 'default' });
        }
        actions.push({ name: textEdit, event: 'edit' });
        actions.push({ name: textDelete, event: 'delete' });

        return {
          textBold: address.firstName + (address.lastName ? ' ' + address.lastName : ''),
          text: [
            (address.houseNumber ? address.houseNumber + ', ' : '') + address.line1,
            address.line2,
            address.town + ', ' + region,
            address.country.isocode + ', ' + address.postalCode,
            this.formatPhone(address.phone)
          ],
          actions,
          // header: address.defaultAddress ? `${address.firstName} (${defaultText})` : address.firstName,
          header: address.defaultAddress ? `✓ ${defaultText}` : '',
          deleteMsg: textVerifyDeleteMsg,
        };
      })
    );
  }

  formatPhone(value) {
    const trim = value?.substring(2);
    const cleaned = ('' + trim).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    } else {
      const removeSpaces = value?.replace(/\s/g, '');
      const trim = removeSpaces?.substring(1);
      const match = trim?.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
      }
    }
  }
}
